/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDeleteOrgMemberOptions, AdminDeleteOrgMemberResponses } from '../../models/AdminDeleteOrgMember'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete Org Member
 * {@link /admin/org/:org_id/member/:user_id}
 */
export function adminDeleteOrgMember<ThrowOnError extends boolean = true>(options: Options<AdminDeleteOrgMemberOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDeleteOrgMemberResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/org/{org_id}/member/{user_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDeleteOrgMemberResponses, ThrowOnError>>
}
